import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsVerified, useSetIsVerified } from '../../state';
import fetchWithToken from '../../services';

const VerifyEmail = () => {
    const isVerified = useIsVerified();
    const setIsVerified = useSetIsVerified();
    const navigate = useNavigate();
    const emailSent = useRef(false);
    const [verificationError, setVerificationError] = useState(null);

    const sendVerificationEmail = async () => {
        try {
            await fetchWithToken('/send-verification-email', {
                method: 'POST'
            });
        } catch (error) {
            console.error('Error sending verification email:', error);
        }
    }

    useEffect(() => {
        if (isVerified === true) {
            navigate('/');
        }
    }, [isVerified, navigate]);

    useEffect(() => {
        if (!emailSent.current) {
            sendVerificationEmail();
            emailSent.current = true;
        }
    }, []);

    const handleVerify = async (e) => {
        console.log('handleVerify function called.');
        e.preventDefault();
        const code = e.target.verificationCode.value;
        const codeString = code.toString();
        console.log('Code:', codeString);
        try {
            const response = await fetchWithToken('/verify-email', {
                method: 'POST',
                body: JSON.stringify({ code: codeString })
            });

            console.log('Response from verify-mail endpoint:', response);

            if (response.status === 200) {
                setIsVerified(true);
            } else if (response.status === 400) {
                const errorData = await response.json();
                console.error('Verification failed:', errorData.error);
                setVerificationError('Verification failed:', errorData.error);
            } else if (response.status === 500) {
                console.error('Server error occurred');
                setVerificationError('Server error occurred. Try refreshing page.');
            }
        } catch (error) {
            console.error('Error verifying email:', error);
            setVerificationError('Server error occurred. Try refreshing page.');
        }
    };


    const handleResendVerificationEmail = async () => {
        if (!isVerified) {
            try {
                await sendVerificationEmail();
            } catch (error) {
                console.error(error);
            }
        }
    };

    // return (
    //     <div>
    //         <p>Please enter the 4-digit verification code sent to your email:</p>
    //         <form onSubmit={handleVerify}>
    //             <input
    //                 type="text"
    //                 name="verificationCode"
    //             />
    //             <button type="submit">Verify</button>
    //         </form>
    //         <button onClick={handleResendVerificationEmail}>Resend verification email</button>
    //         {verificationError && <p className="error-message">{verificationError}</p>}
    //     </div>
    // )

    return (
        <div className="page-background flex relative">
            <div className="p-6 rounded-lg max-w-md mx-auto ml-4 mr-4">
                <p className="mb-4 text-base text-white">Please enter the 6-digit verification code sent to your email:</p>
                <form onSubmit={handleVerify} className="mb-4">
                    <input
                        type="text"
                        name="verificationCode"
                        maxLength="6"
                        className="credential-input mb-4 mx-auto text-center w-48 text-lg"
                    />
                    <div className="flex justify-center">
                        <button 
                            type="submit"
                            className="w-36 py-2 px-4 bg-orange-200 text-black font-semibold rounded-lg hover:bg-orange-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75"
                        >
                            Verify
                        </button>
                    </div>
                </form>
                <div className="flex justify-center">
                    <button 
                        onClick={handleResendVerificationEmail}
                        className="w-36 py-2 bg-gray-200 text-gray-700 font-semibold rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-75"
                    >
                        Resend email
                    </button>
                </div>
                {verificationError && <p className="mt-4 text-red-500">{verificationError}</p>}
            </div>
        </div>
    );
};

export default VerifyEmail;